// A field's mark: an error once it's invalid, a check once it holds a valid value
export const getFieldStatus = (filled: boolean, valid: boolean) => {
  if (!filled) return undefined

  return valid ? "success" : "error"
}
